export { SkillSales as default } from './SkillSales';
